module.exports = __webpack_public_path__ + "img/two.939d2549.svg";